module.exports = __webpack_public_path__ + "8d81e41e8eff1f1d23cfbe7cf2ae22e7.fbx";